import Vue from 'vue'
import VueResource from 'vue-resource';
import App from './App.vue';
import store from './Store/store';
import vuelidate from 'vuelidate';
import './registerServiceWorker';

/* FRAMEWORK 7 */
import Framework7 from 'framework7/framework7.esm.bundle.js';
import Framework7Vue from 'framework7-vue/framework7-vue.esm.bundle.js';
import Framework7Styles from 'framework7/css/framework7.css';
import Framework7Icons from "framework7-icons/css/framework7-icons.css";

// Import Icons and App Custom Styles
// eslint-disable-next-line
import IconsStyles from './css/icons.css';
// eslint-disable-next-line
import AppStyles from './css/app.css';
// eslint-disable-next-line
import CustomStyle from './css/custom.css';

Framework7.use(Framework7Vue,Framework7Styles,Framework7Icons);

/* VUE RESOURCE */
Vue.use(VueResource);

const hostname = window.location.hostname;

if(hostname == 'localhost') {
    Vue.http.options.root = 'http://local.todo.horeca/api/';
}else{
    Vue.http.options.root = '/api/';
}


/* MISC */
Vue.use(vuelidate);
Vue.config.productionTip = false;

Vue.prototype.$parseJWT = function (token) {
    if (token == '' || token == null) {
        return {}
    }
    var base64Url = token.split('.')[1];
    var base64 = base64Url.replace('-', '+').replace('_', '/');
    return JSON.parse(window.atob(base64));
};

new Vue({
    store,
    render: h => h(App)
}).$mount('#app')
